import { createAction } from "redux-actions";

import * as types from "./types";

export const receiveDeal = createAction(types.RECEIVE_DEAL, (deal) => deal);
export const receiveDeals = createAction(types.RECEIVE_DEALS, ({ deals }) => ({
  deals,
}));
